<template>
  <div class="chat-input px-4">
    <textarea
      ref="input"
      v-model="chatInput" class="full-width lh-1-2 pa-3 grey500"
      maxlength="255" rows="3"
      :readonly="isSending"
      :placeholder="$t('layout.chat.input.placeholder')"
      @keydown="onKeyDown"
    />
  </div>
</template>

<script>
import {
  KEY_AC_DOWN, KEY_AC_SELECT, KEY_AC_UP, KEY_SEND,
} from '@/utils/constants/chat'

// TODO chat send doesnt work on mobile android

export default {
  props: {
    input: {
      type: String,
      required: true,
    },
    autocomplete: {
      type: Object,
      required: true,
    },
    isSending: Boolean,
  },
  computed: {
    chatInput: {
      get() {
        return this.input
      },
      set(val) {
        this.$emit('update:input', val)
      },
    },
  },
  methods: {
    onKeyDown(event) {
      const { key } = event
      const { open: acOpen } = this.autocomplete

      switch (key) {
        case KEY_SEND: {
          event.preventDefault()

          if (acOpen) {
            this.$emit('autocomplete-action', 'select')
          } else {
            this.$emit('send', this.input)
          }

          break
        }

        case KEY_AC_SELECT: {
          if (!acOpen) return
          event.preventDefault()
          this.$emit('autocomplete-action', 'select')
          break
        }

        case KEY_AC_UP: {
          if (!acOpen) return
          event.preventDefault()
          this.$emit('autocomplete-action', 'up')
          break
        }

        case KEY_AC_DOWN: {
          if (!acOpen) return
          event.preventDefault()
          this.$emit('autocomplete-action', 'down')
          break
        }

        default:
          break
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.chat-input {
  textarea {
    display: block;
    margin: 0;
    outline: none;
    color: grey(100);
    box-shadow: 0 4px 6px rgba(black, 0.2);
    resize: none;
  }
}
</style>
